// extracted by mini-css-extract-plugin
module.exports = {"arrow":"carousel-module--arrow--19qnv","reversed":"carousel-module--reversed--q8Kq1"};